<template>
    <MainPage @clickBack="clickBack()" :showTopTitle="false">
        <div class="max-w-sm m-auto px-4">
            <div class="text-18 text-a-brown-502314 font-bold text-center mt-6">{{titleText}}</div>
            <div class="mt-3">
                <img class="w-8 m-auto" src="../../../assets/password/ic-lock.svg">
            </div>
            <div class="mt-3 text-a-brown-502314 text-14 text-center">
                This esnsure only you can access your account.
            </div>
            <InputPin
                    ref="input-pin"
                    v-model:inputValue="inputPass"
            ></InputPin>
            <router-link to="/resetpassword"
                    v-show="state == 'oldpass'"
                    class="block text-a-red-d62300 font-bold text-16 text-center cursor-pointer mt-8">
                Forgot PIN?
            </router-link>
            <div class="w-255px m-auto mt-8">
                <RedButton v-show="state != 'oldpass'" @click="clickSubmit()">
                    Submit
                </RedButton>
            </div>
        </div>
    </MainPage>
</template>
<script>
import Util from '@/helper/Utility.js';
//component
import MainPage from '@/components/Layout/Page/MainPage.vue';
import InputPin from '@/components/Input/simple/InputPin.vue';
import RedButton from '@/components/Button/RedButton.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
//service
import ResetPasswordApi from '../service/ResetPasswordApi.js';

export default {
    mixins: [ModalMixin],
    components: {
        MainPage,
        InputPin,
        RedButton,
    },
    data: function () {
        return {
            state: 'newpass', //newpass, confirmpass

            inputPass: '',

            newPass: '',
            confirmPass: '',

            email: '',
            refcode: '',
        };
    },
    computed: {
        titleText: function () {
            if (this.state == 'newpass') {
                return 'Please setup PIN';
            } else if (this.state == 'confirmpass') {
                return 'Comfirm PIN';
            } else {
                return '';
            }
        },
    },
    created: function () {
        this.getParamsReset();
    },
    methods: {
        getParamsReset: function () {
            this.email = this.$route.query.email;
            this.refcode = this.$route.query.refcode;

            if (Util.isEmptyStr(this.email) || Util.isEmptyStr(this.refcode)) {
                this.$router.replace('/error');
            }
        },

        clickSubmit: function () {
            if (this.state == 'newpass' && this.validateInputPassword()) {
                this.newPass = this.inputPass;
                this.state = 'confirmpass';
                this.clearInput();
            } else if (this.state == 'confirmpass' && this.validateInputPassword()) {
                this.confirmPass = this.inputPass;
                this.sendChangePassword();
            }
        },
        clearInput: function () {
            this.inputPass = '';
            this.$refs['input-pin'].clearInput();
        },

        validateInputPassword: function () {
            return this.inputPass.length == 6;
        },

        sendChangePassword: async function () {
            if (!this.validateNewPassword()) {
                return;
            }

            Util.log('password', this.newPass);
            Util.log('confirm', this.confirmPass);

            this.modal.loadingModal.show();
            let rs = await this.apiResetPassword()
            this.modal.loadingModal.hide();
            if (rs) {
                this.$router.replace('/home');
            } else {
                this.state = 'newpass';
                this.clearInput();
            }
        },

        validateNewPassword: function () {
            if (this.newPass != this.confirmPass) {
                this.modal.errorModal
                    .clearModal()
                    .setMsg('Password not match')
                    .show();

                this.state = 'newpass';
                this.clearInput();

                return false;
            }
            return true;
        },

        apiResetPassword: function () {
            return new Promise((resolve) => {
                ResetPasswordApi.apiResetPasswordEmail(this.email, this.refcode, this.newPass).subscribe({
                    next: (data) => {
                        console.log('reset password', data);
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
